import React, { useCallback, useState } from "react";
import InternalDrawer from "../../common/InternalDrawer";
import SvgRightCaret from "../../../assets/icons/SvgCaretDown";
import { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { removePrice, updateFilter } from "../../../slices/filter";
import { PRICE } from "../constants";

function PriceDrawer({ isOpen, setDrawer }) {
  const { filter } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  const debounceFn = useCallback(debounce(handleDebounceFn, 1000), []);
  const [amount, setAmount] = useState(filter.price);

  function handleUpdateFilter(key, value) {
    dispatch(updateFilter({ key, value }));
  }

  function handleRemovePrice() {
    dispatch(removePrice());
  }

  function handleAmount(e) {
    setAmount((prevVal) => ({ ...prevVal, [e.target.name]: e.target.value }));
    debounceFn({ ...amount, [e.target.name]: e.target.value });
  }
  function handleDebounceFn(amount) {
    handleUpdateFilter(PRICE, amount);
  }

  return (
    <InternalDrawer isOpen={isOpen} rootProps={{ bgColor: "bg-white" }}>
      <div className="flex flex-col py-[15px] px-5 bg-full bg-center overflow-y-auto">
        <div
          className="px-[10px] py-[15px] flex items-center cursor-pointer"
          role="button"
          onClick={() => setDrawer("home")}
        >
          <SvgRightCaret
            style={{
              width: "12px",
              height: "12px",
              transform: "rotate(90deg)",
            }}
          />
          <span className="grow ml-1">Price</span>
        </div>
        <p>The heighest price is</p>
        <div className="flex gap-9">
          <div className="flex gap-3">
            $
            <div className="flex flex-col">
              <input
                className="bg-[rgb(242,242,242)] w-[90%] px-[10px] border-b border-solid border-b-gray-700 placeholder:text-gray-700 h-10"
                placeholder="0"
                type="number"
                id="min"
                name="min"
                key="min"
                value={amount.min}
                onChange={handleAmount}
              />
              <span className="text-xs text-gray-500 mt-[5px]">From</span>
            </div>
          </div>
          <div className="flex gap-3">
            $
            <div className="flex flex-col">
              <input
                className="bg-[rgb(242,242,242)] w-[90%] px-[10px] border-b border-solid border-b-gray-700 placeholder:text-gray-700 h-10"
                placeholder="299999.00"
                type="number"
                id="max"
                name="max"
                key="max"
                value={amount.max}
                onChange={handleAmount}
              />
              <span className="text-xs text-gray-500 mt-[5px]">To</span>
            </div>
          </div>
        </div>
      </div>
    </InternalDrawer>
  );
}

export default React.memo(PriceDrawer);
